import { Component, Renderer2, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxButtonModule } from '../button/button.module';


@Component({
  selector: 'rx-applications-fixed-bottom-expander',
  standalone: true,
  imports: [CommonModule, RxButtonModule],
  templateUrl: './fixed-bottom-expander.component.html',
  styleUrls: ['./fixed-bottom-expander.component.scss'],
})
export class FixedBottomExpanderComponent {
  @Input() expandButtonText = "";
  @Input() collapseButtonText = "";
  @Input() isBodyExpanded = false;
  @Input() allowBackgroundScroll = true;

  constructor(private renderer: Renderer2) { }

  toggleIsBodyExpanded(): void {
    this.isBodyExpanded = !this.isBodyExpanded;
    if (!this.allowBackgroundScroll) {
      this.isBodyExpanded
        ? this.renderer.addClass(document.body, 'noscroll')
        : this.renderer.removeClass(document.body, 'noscroll');
    }
  }
}
